import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import superAdminApi from '../../utils/superAdminApi';
import toast from 'react-hot-toast';
import { FiArrowLeft } from 'react-icons/fi';

// Read-only cross-shop bill view — the Super Admin oversight surface, not
// a replacement for the shop-facing BillDetail.jsx (which has PDF/email/
// print actions scoped to the shop's own auth token).
export default function SuperAdminSaleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    superAdminApi.get(`/sales/${id}`).then(r => { setBill(r.data.bill); setLoading(false); })
      .catch(() => { toast.error('Bill not found'); navigate('/superadmin/sales'); });
  }, [id, navigate]);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;
  if (!bill) return null;

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <button className="btn btn-outline btn-sm" onClick={() => navigate('/superadmin/sales')}>
          <FiArrowLeft size={14} /> Back
        </button>
      </div>

      <div className="card bill-preview" style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #1e293b', paddingBottom: 20, marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#1e293b' }}>INVOICE</div>
            <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Bill #{bill.billNumber}</div>
            <div style={{ fontSize: 13, color: '#64748b' }}>
              {new Date(bill.billDate).toLocaleDateString('en-AE', { timeZone: 'Asia/Riyadh', day: 'numeric', month: 'long', year: 'numeric' })}
            </div>
            <div style={{ marginTop: 8, display: 'flex', gap: 6 }}>
              <span className={`badge badge-${bill.status === 'paid' ? 'success' : bill.status === 'partial' ? 'info' : 'warning'}`}>
                {bill.status.toUpperCase()}
              </span>
              <span className="badge badge-gray">{bill.shopId?.name || 'Unknown shop'}</span>
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 18, fontWeight: 700 }}>Customer</div>
            <div style={{ fontSize: 15, fontWeight: 600, marginTop: 4 }}>{bill.customerName}</div>
            <div style={{ fontSize: 13, color: '#64748b' }}>{bill.customerPhone}</div>
          </div>
        </div>

        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
          <thead>
            <tr style={{ background: '#1e293b', color: 'white' }}>
              <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 12 }}>Description</th>
              <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: 12 }}>Qty</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontSize: 12 }}>Price</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontSize: 12 }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {bill.items.map((item, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '10px 12px' }}>{item.description}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>{item.quantity}</td>
                <td style={{ padding: '10px 12px', textAlign: 'right' }}>SAR {item.price?.toFixed(2)}</td>
                <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>SAR {item.total?.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ width: 280 }}>
            {[
              ['Subtotal', `SAR ${bill.subtotal?.toFixed(2)}`],
              [`VAT (${bill.vatPercent}%)`, `SAR ${bill.vatAmount?.toFixed(2)}`],
            ].map(([l, v]) => (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13 }}>
                <span>{l}</span><span>{v}</span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: '2px solid #1e293b', fontWeight: 700, fontSize: 16 }}>
              <span>Grand Total</span><span>SAR {bill.total?.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 13 }}>
              <span>Advance Paid</span><span style={{ color: '#10b981', fontWeight: 600 }}>SAR {bill.advancePaid?.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: bill.remaining > 0 ? '#fee2e2' : '#d1fae5', borderRadius: 6, fontWeight: 700 }}>
              <span>Remaining</span>
              <span style={{ color: bill.remaining > 0 ? '#ef4444' : '#10b981' }}>SAR {bill.remaining?.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
